<div class="from-top container-fluid" infiniteScroll [infiniteScrollDistance]="2" (scrolled)="onScroll()">
    <div class="col-md-12 my-5 clr-sec-text text-center" *ngIf="!results?.length">
        <h2>{{'gen_no_data' | translate}}</h2>
    </div>
    <app-waterfall [assets]="results" *ngIf="results?.length"></app-waterfall>
</div>